// ------------------ brand (static)
/* eslint-disable no-unused-vars */

window.userLocations = [
	{
		location: 'Alberta',
		code: 'ab',
	},
	{
		location: 'British Columbia',
		code: 'bc',
	},
	{
		location: 'Manitoba',
		code: 'mb',
	},
	{
		location: 'New Brunswick',
		code: 'nb',
	},
	{
		location: 'Newfoundland and Labrador',
		code: 'nl',
	},
	{
		location: 'Nova Scotia',
		code: 'ns',
	},
	{
		location: 'Ontario',
		code: 'on',
	},
	{
		location: 'Quebec',
		code: 'qc',
	},
	{
		location: 'Prince Edward Island',
		code: 'pe',
	},
	{
		location: 'Saskatchewan',
		code: 'sk',
	},
];
const BRAND = (() => {
	// private var(s)

	// function that will replace all instances of {PR} or escaped /%7BPR%7D/ in string with
	// provinceCode from regionCode cookie
	const _replaceStringProvinceCode = (st) => {
		/* eslint-disable-next-line */
		//document.cookie.match('(^|;)\\s*' + 'regionCode' + '\\s*=\\s*([^;]+)')?.pop() || '';
		let url = st;
		const province = Utils.getCookie('regionCode');
		const re = /%7BPR%7D/gi; // escaped version from AEM
		const re2 = /{PR}/gi;
		if (province) {
			url = url.replace(re, province);
			url = url.replace(re2, province);
		}
		return url;
	};

	// private method(s)
	const _constructor = () => {
		// _bindEvents();
		// console.log('Brand is running');

		const lang = document
			.getElementsByTagName('html')[0]
			.getAttribute('lang');
		if (lang) {
			I18n.initDictionary('vuse', lang); // setup the i18n dictionary
		}

		const $document = $(document);
		// Replace {PR} in default messageBar text with province code
		$document.on('BATComponentsLoaded', () => {
			// update all links in Header 'top' area
			$('.bat-messagebar--default-message a').each((index, a) => {
				const $a = $(a);
				let href = $a.prop('href');
				if (href) {
					href = _replaceStringProvinceCode(href);
					$a.attr('href', href);
				}
			});
		});

		// If current environment is Styleguide/Prototype environment and no regionCode cookie is set,
		// then set cookie to default AB (Alberta) province
		province = Utils.getCookie('regionCode');
		const { domain } = document;
		if (!province) {
			if (domain.includes('localhost') || domain.includes('styleguide')) {
				Utils.setCookie('regionCode', 'AB');
			}
		}
	};

	// Bind Events
	const _bindEvents = () => {
		// console.log('Bind Events Here');
	};

	_constructor();

	// output/public
	return {
		bindEvents: _bindEvents,
		replaceStringProvinceCode: _replaceStringProvinceCode,
	};
})();
